var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isIdle)?_c('ModalIdle'):_vm._e(),_c('barra-navegacao'),_c('v-content',[_c('div',{staticClass:"container"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }